module.exports = __webpack_public_path__ + "img/y-134.fce375a9.png";